// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"6a01421a","526":"b89821d3","787":"d6eddec9","995":"408e0ad2"}[chunkId] + ".chunk.js";
};